<template>
    <b-row class="content-element animated fadeIn">
        <b-col v-if="file" class="recurso-selected" >
            <img v-if="tipo == 'IMAGEN'" :src="$root.setUrlFile(file)" alt="" class="img-recurso-prev">
            <b-col v-else-if="tipo == 'AUDIO'" class="audio-element mb-3">
                <font-awesome-icon icon="volume-down" class="animated infinite heartBeat" />
                <audio :src="$root.setUrlFile(file)" controls="controls" autobuffer="autobuffer"></audio>
            </b-col>
            <video v-else controls class="video-recurso-prev">
                <source :src="$root.setUrlFile(file)">  
            </video>
        </b-col>
        <b-col v-else class="insert-img-constructor" @click="openModalGaleria">
            <slot v-if="tipo == 'IMAGEN'">
                <font-awesome-icon icon="file-image" />
                <p class="p-texto-img">Clic para Insertar una Imagen</p>
            </slot>
            <slot v-else-if="tipo == 'VIDEO'">
                <font-awesome-icon icon="file-video" />
                <p class="p-texto-img">Clic para Insertar un Video</p>
            </slot>
            <slot v-else-if="tipo == 'AUDIO'">
                <font-awesome-icon icon="file-audio" />
                <p class="p-texto-img">Clic para Insertar un Audio</p>
            </slot>
        </b-col>
        <options-element :index-element="idElement" :index-column="idColumn" :editable="true" v-on:edit-clicked="onEdit"></options-element>
       <!-- <b-modal size="lg" title="Elija una imagen" :id="'modal-manage-galeria-'+idElement" class="cme-modal modal-recursos" :ref="'modal-manage-galeria-'+idElement" @hidden="resetFilter">
            <cTable v-on:row-clicked="insertImage($event)" :table-data="listRecursos" :fields="tableFields" caption="Resultados"></cTable>
        </b-modal>-->   
        <!-- Modal recursos -->
        <ModalRecursos :id="'modal-manage-galeria-'+idElement" :showModal="showModal" v-on:closeModal="showModal = $event" :typeRecurso="typeRecurso" v-on:data-selected="insertImage($event)"></ModalRecursos>
    </b-row>
</template>
<script>
    import cTable from "@/components/TableContent";
    import ModalRecursos from '@/components/ModalRecursos/'
    import InlineEditor from '@ckeditor/ckeditor5-build-inline/build/ckeditor';
    import RecursoService from "@/services/recurso.service";
    import OptionsElement from './OptionsElement';
    export default {
    name: 'recurso',
    props:{
        tipo:{type:String,default:'IMAGEN'},
        recursoSelected: {type:String, default:null},
        idElement: {type: Number},
        idColumn: { type:Number, default: null }
    },
    components: {
        cTable,
        OptionsElement,
        ModalRecursos
    },
    data(){
        return {
            listRecursos: [],
            dataPagination: {
                page: 1,
                limit: 0,
                totalDocs:0,
                totalPages:0,
            },
            typeRecurso: this.tipo,
            tableFields: [
                {key: 'nombre', label: 'Nombre', sortable: true},
                {key: 'file', label: 'Imagen'},
                {key:'tags', label: 'Tags'},
                { key: 'fechaCreacion', label:'Creado', sortable:true }
            ],
            file: this.recursoSelected,
            showModal: false,
            dataProcessModal:null
        }
    },
    methods: {
        insertImage(e) {
            this.file = e.file;
            //this.$refs['modal-manage-galeria-'+this.idElement].hide();
            this.showModal = false;
        },
        openModalGaleria() {
            console.log(this.typeRecurso);
            //this.$refs['modal-manage-galeria-'+this.idElement].show();
            this.showModal = true;
        },
        onEdit() {
            console.log('entra al metodo editar');
            this.openModalGaleria();
        }
    },
    watch: {
        file: function(aft) {
            // se actualiza en el $store el contendio del parrafo con referencia a su posición en el arreglo matriz y   si está posicionado dentro de una columna.
            this.$store.dispatch('constructor/updateContentElement',{
                indexElement: this.idElement, 
                data: aft,
                field: 'file', 
                indexColumns: this.idColumn
            });
        }
    }
}
</script>
<style lang="scss">
    .insert-img-constructor {
        text-align: center;
        padding: 1rem;
        align-self: center;

        svg {
            font-size: 2rem;
        }
        svg, p:hover{
            cursor: pointer;
        }
        &:hover{
            cursor:grab;
        }
    }

    .modal-recursos .modal-dialog {
        max-width: 80vw !important;
    }

    .recurso-selected {
        margin: auto 0;
        img,video,audio {
            display: block;            
        }
        img,video {
            max-width: 100%;
        }
        &:hover {
            cursor:grab;
        }
    }
    .content-element{
        border-style: dashed;
        border-radius: .2rem;
        border-color: #d6d6d6;
        margin: 5px;
    }
    .p-texto-img{
        padding: 0;
        margin: 0;
    }
    .img-recurso-prev{
        width: 350px;
        height: 320px;
        margin: 10px auto;
    }
    .video-recurso-prev{
        width: 460px;
        height: auto;
        margin: 10px auto;
    }
</style>
